<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <h3
        style="color:black; margin: 0px; font-family:arial; cursor:pointer;"
        @click="$router.push('home')"
      >
        WhoDrinks
      </h3>
      <!-- <img
        src="/img/WhoDrinks.png"
        :alt="$t('menu.image')"
        style="width:130px; cursor:pointer;"
        @click="$router.push('home')"
      /> -->
      <button
        type="button"
        class="navbar-toggler navbar-toggler-right"
        :class="{ toggled: $sidebar.showSidebar }"
        aria-controls="navigation-index"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleSidebar"
      >
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" href="#/">
              <b>
                {{ $t("menu.home") }}
              </b>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#/wheel-play">
              <b>
                {{ $t("menu.wheel") }}
              </b>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#/lottery">
              <b>
                {{ $t("menu.lottery") }}
              </b>
            </a>
          </li>
          <li v-if="linguaPortuguesa" class="nav-item">
            <a class="nav-link" href="#/never-have">
              <b>
                {{ $t("menu.neverHave") }}
              </b>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#/finger-selector">
              <b>
                {{ $t("menu.fingerSelector") }}
              </b>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#/where-is-it">
              <b>
                {{ $t("menu.whereIsIt") }}
              </b>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#/simon">
              <b>
                {{ $t("menu.simon") }}
              </b>
            </a>
          </li>
          <li v-if="!linguaPortuguesa" class="nav-item">
            <a class="nav-link" href="#/truth-or-drink">
              <b>
                {{ $t("menu.truthOrDrink") }}
              </b>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { mixin } from "src/mixin";

export default {
  mixins: [mixin],

  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      activeNotifications: false,
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
  },
};
</script>
<style></style>
